import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import { Button } from "react-admin";
import { connect } from "react-redux";

class DownloadButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      downloading: false,
      premiumAttivato: (
        props.record !== undefined
          ? props.record.hasOwnProperty("premiumAttivato")
          : false
      )
        ? props.record.premiumAttivato
        : false,
    };
  }

  downloadReport = () => {
    const { record } = this.props;
    let ctx = this;
    ctx.setState({ downloading: true });

    axios
      .get(window.BaseURL + `/gse/generapdf/${record.id}`, {
        responseType: "blob",
        headers: {
          Accept: "application/pdf",
          Authorization: `Bearer ${localStorage.getItem("auth")}`,
        },
      })
      .then((response) => {
        const url = URL.createObjectURL(response.data);
        ctx.setState({ downloading: false });
        //var blob = new Blob([data.body], { type: 'application/pdf' });
        //let url = window.URL.createObjectURL(blob);

        //var date = Moment(new Date()).format("YYYY_MM_DD-HH_mm_ss");

        // Creating the hyperlink and auto click it to start the download
        let link = document.createElement("a");
        link.href = url;
        const filename = response.headers["x-suggested-filename"];
        link.download = filename;
        link.click();
      })
      .catch(function (error) {
        ctx.setState({ downloading: false });
        alert(`Non è stato possibile scaricare il file.\n${error}`);
        console.log(error);
      });
  };

  attivaPremium = () => {
    const { record } = this.props;
    let ctx = this;
    ctx.setState({ downloading: true });

    //    notify(`Premium attivato`, "success", undefined, false);
    axios
      .post(window.BaseURL + `/gse/attivaPremium`, [record], {
        headers: {
          Accept: "application/pdf",
          Authorization: `Bearer ${localStorage.getItem("auth")}`,
        },
      })
      .then((response) => {
        console.log("premium attivato");
        ctx.setState({ premiumAttivato: true });
        ctx.setState({ downloading: false });
        //notify(`Premium attivato`, "success", undefined, false);
      })
      .catch(function (error) {
        ctx.setState({ downloading: false });
        alert(`Non è stato possibile attivare il premium.\n${error}`);
        console.log(error);
      });
  };

  render() {
    let downloadBtn = (
      <Button
        label="Scarica Report"
        color="primary"
        disabled={this.state.downloading}
        // startIcon={<GetAppIcon />}
        onClick={(e) => {
          e.stopPropagation();
          this.downloadReport();
        }}
      />
    );

    let premiumBtn = (
      <Button
        label="Attiva premium"
        onClick={(e) => {
          e.stopPropagation();
          this.attivaPremium();
        }}
      />
    );

    return (
      <Fragment>
        {this.state.downloading ? (
          <CircularProgress size={18} thickness={5} />
        ) : this.state.premiumAttivato ? (
          downloadBtn
        ) : (
          premiumBtn
        )}
      </Fragment>
    );
  }
}

DownloadButton.propTypes = {
  record: PropTypes.object,
};

export default connect(null, {})(DownloadButton);
